import React, { useEffect, useState } from 'react';

export default function CookiePopup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const isAccepted = localStorage.getItem('cookiesAccepted');
    const isDeclined = localStorage.getItem('cookiesDeclined');
    if (!isAccepted && !isDeclined) {
      setShowPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowPopup(false);
  };

  const handleCancel = () => {
    localStorage.setItem('cookiesDeclined', 'true');
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="cookie-popup">
      <p>
        We use cookies to enhance your experience. By continuing to visit this site,
        you agree to our use of cookies. See our{' '}
        <a href="/cookies" target="_blank" rel="noopener noreferrer">
          Cookie Policy
        </a>.
      </p>
      <div className="cookie-buttons">
        <button className="accept" onClick={handleAccept}>Accept</button>
        <button className="cancel" onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  );
}
